import { useEffect } from "react";

interface Props {
  title: string;
}

export function useDocumentTitle({ title }: Props) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
